export default {"src":"/_next/static/media/steam.b877c7dc.svg","height":41,"width":135};